<template>
  <LoginLayout>
    <div class="flex justify-end p-5 right-1">
      <!-- <inertia-link href="/admin/login">
              <ViceButton icon="LockOpenIcon" data-cy="admin-access" teal>Admin access</ViceButton>
            </inertia-link> -->
      <ViceButton href="/admin/login" icon="LockOpenIcon" data-cy="admin-access" teal>
        Admin access
      </ViceButton>
    </div>
    <div class="login-form-wrapper flex flex-col h-full gap-6">
      <div class="flex flex-col md:flex-row gap-3 sm:gap-12 items-center mt-30">
        <div class="flex flex-col h-full">
          <div
            class="flex flex-col md:text-center md:mb-3 bg-white rounded-lg shadow group pb-6 w-80"
          >
            <div class="flex-1 flex md:flex-col p-6 items-center">
              <div class="flex-col w-full">
                <div class="flex justify-around relative">
                  <h3 class="text-gray-900 text-l font-medium">
                    {{ loginRoles[0].name }}
                  </h3>
                  <img
                    class="absolute top-0 right-0"
                    src="/image/icons/clinician-icon.svg"
                    alt="clinician-icon"
                  />
                </div>
                <dl class="flex-grow flex flex-col justify-between">
                  <dd class="text-gray-500 text-sm">{{ loginRoles[0].title }}</dd>
                </dl>
              </div>
            </div>

            <div class="flex flex-col gap-3 items-center px-4">
              <inertia-link :href="loginRoles[0].loginPath" class="w-full">
                <ViceButton
                  data-cy="clinician-log-in-welcome"
                  class="w-full justify-center"
                  style="background: #0f766e; box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05)"
                >
                  Log in
                </ViceButton>
              </inertia-link>
              <p class="clinician-login-message">
                If you want to register as a VCE Clinician, please get into contact with the
                administrator of your faculty
              </p>
            </div>
          </div>
        </div>
        <div class="w-px h-0 md:h-64"></div>
        <div class="flex flex-col h-full">
          <div
            class="flex flex-col md:text-center md:mb-3 bg-white rounded-lg shadow group pb-6 w-80"
          >
            <div class="flex-1 flex md:flex-col p-6 items-center">
              <div class="flex-col w-full">
                <div class="flex justify-around relative">
                  <h3 class="text-gray-900 text-l font-medium">
                    {{ loginRoles[1].name }}
                    <img
                      class="absolute left-0 top-0"
                      src="/image/icons/users-icon.svg"
                      alt="users-icon"
                    />
                  </h3>
                </div>
                <dl class="flex-grow flex flex-col justify-between">
                  <dd class="text-gray-500 text-sm">{{ loginRoles[1].title }}</dd>
                </dl>
              </div>
            </div>

            <div class="flex flex-col gap-3 items-center px-4">
              <inertia-link :href="route(loginRoles[1].loginRoute)" class="w-full">
                <ViceButton
                  data-cy="user-log-in-welcome"
                  class="w-full justify-center"
                  style="
                    color: #3730a3;
                    background: #e0e7ff;
                    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
                  "
                >
                  Log in
                </ViceButton>
              </inertia-link>

              <span class="flex items-center">
                <span class="flex h-px w-12 bg-gray-200"></span>
                <span class="text-xxs text-gray-600 px-4">or</span>
                <span class="flex h-px w-12 bg-gray-200"></span>
              </span>

              <inertia-link :href="route(loginRoles[1].registerRoute)" class="w-full">
                <ViceButton
                  data-cy="user-register-welcome"
                  class="w-full justify-center"
                  dark
                  style="background: #3730a3; box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05)"
                >
                  Register
                </ViceButton>
              </inertia-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <WelcomeTestConnection />
  </LoginLayout>
</template>

<script>
import ViceButton from '@/Components/Buttons/ViceButton.vue';
import LoginLayout from '../Layouts/LoginLayout.vue';
import WelcomeTestConnection from '@/Components/TestCenter/WelcomeTestConnection.vue';

export default {
  props: {
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    privacyPolicyRoute: String,
  },
  components: {
    ViceButton,
    LoginLayout,
    WelcomeTestConnection,
  },
  setup(props) {
    const loginRoles = [
      {
        name: 'VCE Clinicians',
        title: 'Can log in here',
        imageUrl: '/image/clinician.svg',
        loginRoute: 'clinician.showLogin',
        loginPath: '/clinician/login',
        registerRoute: 'clinician.register',
      },
      {
        name: 'Attendees',
        title: 'Can log in or register here',
        imageUrl: '/image/student.svg',
        loginRoute: 'login',
        registerRoute: 'register',
      },
    ];
    const privacyPolicyUrl = props.privacyPolicyRoute;
    return {
      loginRoles,
      privacyPolicyUrl,
    };
  },
};
</script>

<style>
.group-hover\:scale\-1\.1 {
  transition: transform 0.5s ease-in-out;
}

.login-form-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.login-form-wrapper > div {
  transform: translateY(-20px);
}

.clinician-login-message {
  color: var(--dark-gray, #606367);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  padding-top: 12px;
}

.group:hover .group-hover\:scale\-1\.1 {
  transform: scale(1.05);
}
.privacy-policy-container {
  position: absolute;
  bottom: 50px;
  width: 100%;
  text-align: center;
}
</style>
